// extracted by mini-css-extract-plugin
export default {"container":"LandingPageHeroSection_container__a-Fef","inputSection":"LandingPageHeroSection_inputSection__o9bYH"};